// @ts-ignore
import HText from "./src/index.vue";
export default HText;